import { render, staticRenderFns } from "./login.vue?vue&type=template&id=5b5ebb23&scoped=true&lang=html&"
import script from "./login.vue?vue&type=script&lang=js&"
export * from "./login.vue?vue&type=script&lang=js&"
import style0 from "./login.vue?vue&type=style&index=0&id=5b5ebb23&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b5ebb23",
  null
  
)

component.options.__file = "login.vue"
export default component.exports